import { serviceCommon } from "./common";
import { apiConstants } from "./constants";

const getPageAbout = async (abortController) => {
   let restObj = {
      method: 'GET',
      headers: {
         'Content-Type': 'application/json',
      },
   }
   if (abortController) {
      restObj.signal = abortController.signal;
   }
   let url = apiConstants.GET_PAGE_ABOUT;

   try {
      let response = await fetch(url, restObj);
      let body = await response.json();
      return body;
   }
   catch (e) {
      return null;
   }
}

const getPageAwards = async (abortController) => {
   let restObj = {
      method: 'GET',
      headers: {
         'Content-Type': 'application/json',
      },
   }
   if (abortController) {
      restObj.signal = abortController.signal;
   }
   let url = apiConstants.GET_PAGE_AWARDS;

   try {
      let response = await fetch(url, restObj);
      let body = await response.json();
      return body;
   }
   catch (e) {
      return null;
   }
}

const getPageContact = async (abortController) => {
   let restObj = {
      method: 'GET',
      headers: {
         'Content-Type': 'application/json',
      },
   }
   if (abortController) {
      restObj.signal = abortController.signal;
   }
   let url = apiConstants.GET_PAGE_CONTACT;

   try {
      let response = await fetch(url, restObj);
      let body = await response.json();
      return body;
   }
   catch (e) {
      return null;
   }
}


const getVideoList = async (requestBody, abortController) => {
   if (!requestBody) {
      return;
   }
   let restObj = {
      method: 'GET',
      headers: {
         'Content-Type': 'application/json',
      },
   }
   if (abortController) {
      restObj.signal = abortController.signal;
   }

   let query = (requestBody.limit !== void 0 ? `_limit=${requestBody.limit}&` : '')
      + (requestBody.start !== void 0 ? `_start=${requestBody.start}&` : '')
      + (requestBody.sort ? `_sort=${requestBody.sort}` : '')
      ;
   let url = apiConstants.GET_VIDEOS(query);

   try {
      let response = await fetch(url, restObj);
      let body = await response.json();
      return body;
   }
   catch (e) {
      return [];
   }
}

export const pagesApi = {
   getPageAbout,
   getPageAwards,
   getPageContact,
   getVideoList,
}